import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import {
  handleUnauthorized,
  showConfirmationDialog,
} from "../../../src/utils/apiHelper";

const ApprovePostListLayer = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
   const [contloading, setcontLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedItems, setSelectedItems] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const authToken = localStorage.getItem("authToken");
  const [showModal, setShowModal] = useState(false);
  const [rejectresone, setRejectResone] = useState("");
  const [rejectId, setRejectId] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, searchQuery, itemsPerPage, sortOrder, sortColumn]);
  const fetchData = async (page) => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/postData?page=${page}&limit=${itemsPerPage}&sort=${sortColumn}&order=${sortOrder}&search=${searchQuery}&status=approved`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      setItems(data.result || []);
      setTotalItems(data.metadata.totalItems || 0);
      setTotalPages(data.metadata.totalPages || 1);
    } catch (error) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const handleSort = (column) => {
    setSortColumn(column);
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItems(items.map((item) => item._id));
    } else {
      setSelectedItems([]);
    }
  };

  const getPaginationRange = () => {
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4);

    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };
  const handleSelectItem = (id) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((item) => item !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const isSelected = (id) => selectedItems.includes(id);
  const handleDeleteAll = async (id, single = "No") => {
    const idsToDelete = single === "Yes" ? [id] : selectedItems;
    if (idsToDelete.length === 0) {
      return;
    }
    const message = `This action will delete the Post!`;
    const confirmmessage = `Yes, delete it!`;
    const result = await showConfirmationDialog(message, confirmmessage);

    if (!result.isConfirmed) return;

    try {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/postDelete`;
      const response = await fetch(API_ENDPOINT, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ id: idsToDelete }),
      });

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const successmessage =
        single === "Yes"
          ? "The post has been deleted successfully"
          : "The posts have been deleted successfully";
      setSuccessMessage(successmessage);
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
      if (single === "No") {
        setSelectedItems([]);
      }
      fetchData(currentPage);
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    }
  };
  const updatePostStatus = async (id, currentStatus) => {
    // const newStatus = currentStatus === 'approved' ? 'reject' : 'approved';
    let newStatus;
    if (currentStatus === "reject") {
      newStatus = "rejected";
    } else {
      newStatus = currentStatus;
    }
    const message = `Do you want to change the status to ${currentStatus}?`;
    if (currentStatus === "reject") {
      if (!showModal) {
        setRejectId(id);
        setShowModal(true);
        return;
      }
      if (!validateInputs()) {
        setLoading(false);
        return;
      }
    }
    let result = { isConfirmed: false };
    if (currentStatus != "reject") {
      result = await showConfirmationDialog(message);
    } else {
      result = { isConfirmed: true };
    }
    if (!result.isConfirmed) return;
    if (result.isConfirmed) {
      try {
        setcontLoading(true);
        const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/postDataupdate/${id}`;
        const response = await fetch(API_ENDPOINT, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            postStatus: newStatus,
            reason: rejectresone,
          }),
        });
        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        setRejectResone(""); // Clear the textarea after submission
        setShowModal(false);
        setSuccessMessage(`Post status ${newStatus} successfully!`);
        setTimeout(() => {
          setSuccessMessage("");
          // fetchData(currentPage,roletype);
        }, 3000);

        fetchData(currentPage);
      } catch (error) {
        setErrorMessage(error.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      }finally {
      setcontLoading(false);
    }
    }
  };
  const validateInputs = () => {
    const newErrors = {};
    if (rejectresone.trim() === "") {
      newErrors.rejectresone = "Reason is required";
    }
    if (!rejectresone) newErrors.rejectresone = "Reason is required";
    setErrors(newErrors);
    if (rejectresone) {
      // if (!/^[A-Za-z\s]+$/.test(rejectresone)) {
      //   newErrors.rejectresone = "Reason must contain only alphabets";
      // }
      if (rejectresone.length < 3) {
        newErrors.rejectresone = "Reason must be at least 3 characters long";
      }
    }
    return Object.keys(newErrors).length === 0;
  };
  const closeModel = () => {
    setRejectResone("");
    setErrors((prev) => ({ ...prev, rejectresone: "" }));
    setShowModal(false);
  };
  return (
    <div className="card h-100 p-0 radius-12">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <span className="text-md fw-medium text-secondary-light mb-0">
            Show
          </span>
          <select
            className="form-select form-select-sm w-auto ps-12 py-6"
            style={{
              fontSize: "16px",
              borderRadius: "7px",
              backgroundPositionX: "unset",
              backgroundPosition: "right 0.75rem center",
            }}
            value={itemsPerPage}
            defaultValue="Select Number"
            onChange={handleItemsPerPageChange}
          >
            <option value="10">10 items per page</option>
            <option value="20">20 items per page</option>
            <option value="50">50 items per page</option>
            <option value="100">100 items per page</option>
          </select>
          <form className="navbar-search" style={{ position: "relative" }}>
            <input
              type="text"
              className="bg-base h-40-px w-auto pe-40" // pe-40 = padding end for space to right-side icons
              name="search"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyUp={(e) => {
                if (e.target.value === "") {
                  setCurrentPage(1);
                }
              }}
              style={{
                paddingRight: searchQuery ? "5rem" : "2.5rem", // more space if clear icon shows
              }}
            />

            {/* Search Icon */}
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{
                position: "absolute",
                right: searchQuery ? "3.25rem" : "1rem",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "1.25rem",
                color: "#999",
                pointerEvents: "none",
              }}
            />

            {/* Clear (Close) Icon */}
            {searchQuery && (
              <button
                type="button"
                onClick={() => {
                  setSearchQuery("");
                  setCurrentPage(1);
                }}
                style={{
                  position: "absolute",
                  right: "1rem",
                  top: "30%",
                  transform: "translateY(-50%)",
                  fontSize: "1.25rem",
                  color: "#000",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <Icon icon="ic:round-close" />
              </button>
            )}
          </form>

          <button
            className="btn btn-danger"
            onClick={handleDeleteAll}
            disabled={selectedItems.length === 0}
          >
            Delete All
          </button>
        </div>
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="d-flex align-items-center gap-10">
                    <div className="form-check style-check d-flex align-items-center">
                      <input
                        className="form-check-input radius-4 border input-form-dark"
                        type="checkbox"
                        name="checkbox"
                        id="selectAll"
                        onChange={handleSelectAll}
                        checked={
                          selectedItems.length === items.length &&
                          items.length > 0
                        }
                      />
                    </div>
                  </div>
                </th>
                <th scope="col">Image</th>
                <th
                  onClick={() => handleSort("title")}
                  style={{ cursor: "pointer" }}
                >
                  Title
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "title" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "title" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("userName")}
                  style={{ cursor: "pointer" }}
                >
                  User Name
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "userName" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "userName" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("createdAt")}
                  style={{ cursor: "pointer" }}
                >
                  Date{" "}
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "createdAt" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "createdAt" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    <span className="loader-15"></span>
                  </td>
                </tr>
              ) : items.length > 0 ? (
                items.map((item, index) => (
                  <tr key={item._id}>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        <div className="form-check style-check d-flex align-items-center">
                          <input
                            className="form-check-input radius-4 border border-neutral-400"
                            type="checkbox"
                            name="checkbox"
                            value={item._id}
                            checked={isSelected(item._id)}
                            onChange={() => handleSelectItem(item._id)}
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      {" "}
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                       <img
                        src={item.banner}
                        alt="Banner"
                        style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '8px' }}
                      />
                      </span>
                    </td>
                    <td>
                      {" "}
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {item.title || "N/A"}
                      </span>
                    </td>
                    <td>
                    <span className="text-md mb-0 fw-normal text-secondary-light">
                      {item.userId?.fullName || item.uploadby || "N/A"}
                    </span>
                  </td>
                    <td>
                      {(() => {
                        const date = new Date(item.createdAt);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                      })()}
                    </td>
                    <td>
                      <span className="text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm">
                        {item.status.charAt(0).toUpperCase() +
                          item.status.slice(1)}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        <button
                          type="button"
                          onClick={() =>
                            navigate(`/approvepost/view-post/${item._id}`)
                          }
                          title="View"
                          className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <Icon
                            icon="majesticons:eye-line"
                            className="icon text-xl"
                          />
                        </button>
                        <button
                          type="button"
                          title="Delete"
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleDeleteAll(item._id, "Yes")}
                        >
                          <Icon
                            icon="fluent:delete-24-regular"
                            className="menu-icon"
                          />
                        </button>
                        <button
                          type="button"
                          title="Reject"
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => updatePostStatus(item._id, "reject")}
                        >
                          <Icon icon="lucide:circle-x" className="menu-icon" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
            {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
            entries
          </span>
          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={handlePrev}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>
            {getPaginationRange().map((page) => {
              return (
                <li key={page} className="page-item">
                  <Link
                    className={`page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${
                      currentPage === page
                        ? "bg-primary-600 text-white"
                        : "bg-neutral-200"
                    }`}
                    to="#"
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </Link>
                </li>
              );
            })}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={handleNext}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div
        class={`custom-modal modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">
                Reject Reason
              </h5>
            </div>
            <div class="modal-body">
              <form className="row gy-3 needs-validation" noValidate>
                <div className="col-md-12">
                  <label className="form-label">Reason</label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="answer"
                    cols="4"
                    rows="5"
                    maxLength={200}
                    value={rejectresone} // Controlled component
                    placeholder="Enter Reason"
                    onChange={(e) => {
                      setRejectResone(e.target.value);
                      setErrors((prev) => ({ ...prev, rejectresone: "" }));
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                        .trimStart(); // Prevent leading spaces
                    }}
                  />
                  {errors.rejectresone && (
                    <p className="text-danger mt-1">{errors.rejectresone}</p>
                  )}
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeModel()}
              >
                Close
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                onClick={() => updatePostStatus(rejectId, "reject")}
              disabled={contloading}
                >
                  {contloading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovePostListLayer;
